import type React from 'react'
import { User2Icon } from 'lucide-react'
import PropTypes from 'prop-types'

interface ImageCropperProps {
    avatar?: string | null
    fullName?: string
}

const ImageCropper: React.FC<ImageCropperProps> = ({
    avatar,
    fullName = '',
}) => {
    const getInitials = (name: string): string => {
        return name
            .trim()
            .split(' ')
            .slice(0, 2)
            .map((word) => word[0])
            .join('')
            .toUpperCase()
    }

    const initials = getInitials(fullName)

    return (
        <div className={'relative w-24 h-24'}>
            {avatar == null ? (
                <div className="w-24 h-24 border-4 border-primary overflow-hidden items-center justify-center flex rounded-full bg-[#E2E8F0]">
                    {initials ? (
                        <span className="text-2xl font-bold text-gray-700">
                            {initials}
                        </span>
                    ) : (
                        <User2Icon size={40} className="text-gray-500" />
                    )}
                </div>
            ) : (
                <div
                    className={
                        'w-24 h-24 border-4 border-primary overflow-hidden  items-center justify-center flex rounded-full'
                    }
                >
                    <img src={avatar || '/placeholder.svg'} alt="Preview" />
                </div>
            )}
        </div>
    )
}

ImageCropper.propTypes = {
    avatar: PropTypes.string,
    fullName: PropTypes.string,
}

export default ImageCropper
